import { RiskProfileStatus } from "Infrastructure/Api/Api";
import type { CodeListItem } from "Models/ICodeListDto";
import { Resources, useResource } from "Translations/Resources";
import { typedObjectEntries } from "Utils/ObjectUtils";
import { useMemo } from "react";

type ListItem = CodeListItem<RiskProfileStatus>;
type Result = Array<ListItem>;

export const useRiskProfileStatusList = () => {
  const { t } = useResource();

  return useMemo<Result>(
    () =>
      typedObjectEntries(RiskProfileStatus).map<ListItem>(([key, value]) => ({
        code: value,
        name: t(Resources.Common.RiskProfileStatus[key]),
      })),
    [t],
  );
};
